import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=0fcc236d&scoped=true&"
import script from "./MessagePreview.vue?vue&type=script&lang=js&"
export * from "./MessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=0fcc236d&prod&lang=scss&scoped=true&"
import style1 from "./MessagePreview.vue?vue&type=style&index=1&id=0fcc236d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc236d",
  null
  
)

export default component.exports